const base = '/homepage/assets';
const flagsBase = '/language-icons';
const industriesBase = '/industries';

export const ASSETS = {
  logoPrimary: `${base}/logo-primary.png`,
  logoMobile: `${base}/logo-mobile.png`,
  logoWhite: `${base}/logo-white-official.png`,
  logoOwl: `${base}/logo-owl.png`,
  lionQr: `${base}/lion-trivia-qr.png`,
  leahDunkle: `${base}/leah-dunkle.png`,
  javanSutton: `${base}/javan-sutton.jpg`,
  leanneWhite: `${base}/leanne-white.jpg`,
  bookQr: `${base}/book-demo-qr.png`,
  phoneIntro: `${base}/phone-trivia-v3.png`,
  phoneQ: `${base}/phone-trivia-q.png`,
  phoneCorrect: `${base}/phone-trivia-correct.png`,
  phoneWrong: `${base}/phone-trivia-wrong-v2.png`,
  owlNight: `${base}/owl-night.png`,
  owlDay: `${base}/owl-day.png`,
  venueBadge: `${base}/venue-badge-v2.png`,
  analyticsLaptop: `${base}/analytics-laptop-v5.png`,
  contentLibrary: `${base}/content-library-v7.png`,
  contentLibraryMobile: `${base}/content-library-v7.png`,
} as const;

export const flagSvg = (code: string) => `${flagsBase}/${code}.png`;

export const industryIcon = (file: string) => `${industriesBase}/${file}.png`;

export const venueLogo = (file: string) => `${base}/logos/${file}.png`;
export const teamImg = (file: string) => `${base}/team/${file}`;
